import isEmpty from "lodash/isEmpty" 

export function progressGenerator(tenantScreeningData, formReady) {
  const { screeningOption, property, agentEmail, renterEmails } = tenantScreeningData
  return [
    {
      name: "Screening",
      pathname: "/[partner]",
      ready: !isEmpty(screeningOption) || formReady?.screeningOption,
    },
    {
      name: "Rental",
      pathname: "/[partner]/property",
      ready: !isEmpty(property) || formReady?.property,
    },
    {
      name: "Applications",
      pathname: "/[partner]/applicant",
      ready: !!((agentEmail && !isEmpty(renterEmails)) || formReady?.applicant),
    },
  ]
}

export function progressGeneratorV2(tenantScreeningData, formReady) {
  const { screeningOption, property, agentEmail, renterEmails } = tenantScreeningData

  return [
    {
      status: (!isEmpty(screeningOption) || formReady?.screeningOption) ? "complete" : "inactive",
      label: '1. Screening options',
      pathname: "/[partner]/v2"
    },
    {
      status: (!isEmpty(property) || formReady?.property) ? "complete" : "inactive",
      label: '2. Property info',
      pathname: "/[partner]/v2/property"
    },
    {
      status: (!!((agentEmail && !isEmpty(renterEmails)) || formReady?.applicant)) ? "complete" : "inactive",
      label: '3. Applicant info',
      pathname: "/[partner]/v2/applicant"
    },
  ]
}